import React from 'react';
import {Alert, Badge, Form, Icon, Input, Button, Select, DatePicker, Row, Col, Radio, Slider, Checkbox } from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {updateSettingsGeneralRequest, createSettingsGeneralRequest, getSettingsSitesRequest} from "../../api/requests";
import {
  getGeneralSettingsCreatePermission,
  getGeneralSettingsUpdatePermission
} from "../../reducers/user/selectors";

import classes from './SettingsGeneralForm.css';
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from 'react-i18next';

const { Option } = Select;

class SettingsGeneralForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
    };
  }

  async componentDidMount() {
    // try {
    //   const { data } = await getSettingsSitesRequest();
    //   this.setState({ sites: data });
    // } catch (e) { if (e.response.status === 401) { this.props.logout();  return; } console.log(e); }
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const settings = {...values, content: values.content || '1'};

          if (this.props.id) {
            await updateSettingsGeneralRequest(this.props.id , settings);
          } else {
            await createSettingsGeneralRequest(settings);
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };


  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { generalSettingsCreatePermission, generalSettingsUpdatePermission, id, isNew } = this.props;

    const isEditable = id ? generalSettingsUpdatePermission : generalSettingsCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.name} <Badge count={this.props.i18n.t('Edit')} style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? this.props.i18n.t('NamespaceSettingsGeneralForm:Add setting') : ''}
          </h4>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t('Name')}:</b>
                <Form.Item>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'name', '')
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t('Name')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col lg={24}>
              <label>
                <b>{this.props.i18n.t('Type')}</b>
                <Form.Item>
                  {getFieldDecorator('setting_type', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'setting_type')
                  })(<Select disabled={!isEditable} placeholder={this.props.i18n.t('NamespaceSettingsGeneralForm:Setting type')} style={{ width: '100%'}} allowClear>
                      <Option value='contact_us_email'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Contact us email')}</Option>
                      <Option value='drug_low_limit_fridge'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Site Fridge - threshold for low drug amounts')}</Option>
                      <Option value='drug_low_limit_pharmacy'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Site Pharmacy - threshold for low drug amounts')}</Option>
                      <Option value='drug_low_limit_depot'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Drug Depot - threshold for low drug amounts')}</Option>
                      <Option value='is_ibm_integration_1_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is IBM integration 1 enabled? 1 / 0')}</Option>
                      <Option value='is_ibm_integration_2_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is IBM integration 2 enabled? 1 / 0')}</Option>
                      <Option value='is_ibm_integration_3_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is IBM integration 3 enabled? 1 / 0')}</Option>
                      <Option value='is_ecoa_integration_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is Ecoa integration enabled? 1 / 0')}</Option>
                      <Option value='password_expire_policy'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Password expire policy(days)')}</Option>
                      <Option value='finance_bill_to'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Finance - bill to')}</Option>
                      <Option value='private_url_expire_policy'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Private url expire policy (seconds)')}</Option>
                      <Option value='disable_private_urls'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Disable private urls')}</Option>
                      <Option value='is_imednet_push_subject_integration_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is iMednet API 1 push subject integration enabled? 1 / 0')}</Option>
                      <Option value='is_imednet_subject_updates_integration_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is iMednet API 2 subject updates integration enabled? 1 / 0')}</Option>
                      <Option value='is_imednet_subject_visits_integration_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is iMednet API 3 subject visits integration enabled? 1 / 0')}</Option>
                      <Option value='is_datafax_push_subject_integration_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is DFDiscover push subject integration enabled? 1 / 0')}</Option>
                      <Option value='is_datafax_subject_updates_integration_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is DFDiscover subject updates integration enabled? 1 / 0')}</Option>
                      <Option value='is_datafax_subject_visits_integration_enabled'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Is DFDiscover subject visits integration enabled? 1 / 0')}</Option>
                      <Option value='ship_drug_with_fastest_expiry_first'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Ship drug with fastest expiry first')}</Option>
                      <Option value='allocate_drug_with_fastest_expiry_first'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Allocate drug with fastest expiry first')}</Option>
                      <Option value='drug_expiry_weekly_monthly'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Drug expiry notification (week/month)')}</Option>
                      <Option value='qi_signs_delegation_log_before_staff'>{this.props.i18n.t('NamespaceSettingsGeneralForm:Qi signs delegation log before staff (0 or 1)')}</Option>
                  </Select>)}
                </Form.Item>
              </label>
            </Col>
            {/*<Col lg={12}>
              <label>
                <b>Site ID</b>
                <Form.Item>
                  {getFieldDecorator('site_id', {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, 'site_id')
                  })(<Select placeholder='Select Site ID' style={{ width: '100%'}} allowClear>
                    {sites.map(site => (
                      <Option key={site.id} value={site.id}>{site.name}</Option>
                    ))}
                  </Select>)}
                </Form.Item>
              </label>
            </Col>*/}
          </Row>

          {!['disable_private_urls', 'finance_bill_to'].includes(getFieldValue("setting_type")) && (<Row gutter={12}>
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t('Value')}:</b>
                <Form.Item>
                  {getFieldDecorator('content', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'content', '')
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t('Content')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>)}

          {getFieldValue("setting_type") === 'finance_bill_to' && (<Row gutter={12}>
            <Col>
              <label>
                <b>{this.props.i18n.t('Value')}:</b>
                <Form.Item>
                  {getFieldDecorator('content', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'content', '')
                  })(
                    <Input.TextArea disabled={!isEditable} placeholder={this.props.i18n.t('Content')} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>)}

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t('Save')}
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              {this.props.i18n.t('Cancel')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  generalSettingsCreatePermission: getGeneralSettingsCreatePermission(state),
  generalSettingsUpdatePermission: getGeneralSettingsUpdatePermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'settings-general' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsGeneralForm)));



// WEBPACK FOOTER //
// ./src/components/SettingsGeneralForm/SettingsGeneralForm.js